module.exports = __webpack_public_path__ + "static/media/paint1.d706dda8.jpg";